
document.addEventListener('DOMContentLoaded', function () {
  var canvas = document.getElementsByClassName('js_canvas')[0];
  var interval = 100;
  var duration = 400;

  if (canvas.length < 1) {
    return;
  }

  var logos = [
    document.getElementById('circle_1'),
    document.getElementById('circle_2'),
    document.getElementById('circle_3'),
    document.getElementById('circle_4'),
    document.getElementById('circle_5'),
    document.getElementById('circle_6'),
    document.getElementById('circle_7'),
    document.getElementById('circle_8'),
    document.getElementById('circle_9'),
    document.getElementById('circle_10')
  ];

  var lines = [
    document.getElementById('line_1'),
    document.getElementById('line_2'),
    document.getElementById('line_3'),
    document.getElementById('line_4'),
    document.getElementById('line_5'),
    document.getElementById('line_6'),
    document.getElementById('line_7'),
    document.getElementById('line_8'),
    document.getElementById('line_9'),
    document.getElementById('line_10'),
    document.getElementById('line_11')
  ];

  setTimeout(function() {
    logos[8].classList.add('visible');
    logos[5].classList.add('visible');
  }, interval * 1);

  setTimeout(function() {
    logos[3].classList.add('visible');
  }, interval * .5);

  setTimeout(function() {
    logos[2].classList.add('visible');
  }, interval * 2);

  setTimeout(function() {
    logos[4].classList.add('visible');
    logos[6].classList.add('visible');
  }, interval * 3);

  setTimeout(function() {
    logos[9].classList.add('visible');
    logos[7].classList.add('visible');
  }, interval * 4);

  setTimeout(function() {
    logos[0].classList.add('visible');
  }, interval * 5);

  setTimeout(function() {
    logos[1].classList.add('visible');
  }, interval * 3.5);

  setTimeout(function() {
    logos[1].classList.add('visible');
  }, interval * 6);

  // ---

  var startOfLines = interval * 6 + duration;

  function extendLine(line, delay) {
    setTimeout(function() {
      var length = line.getTotalLength();
      line.style.strokeDasharray = length;
      line.style.strokeDashoffset = length;
      line.classList.add('visible');
    }, delay);
  }

  extendLine(lines[0], startOfLines + duration * 0);
  extendLine(lines[1], startOfLines + duration * 1);
  extendLine(lines[2], startOfLines + duration * 1);
  extendLine(lines[3], startOfLines + duration * 2);
  extendLine(lines[4], startOfLines + duration * 2);
  extendLine(lines[10], startOfLines + duration * 2);
  extendLine(lines[5], startOfLines + duration * 2);
  extendLine(lines[6], startOfLines + duration * 3);
  extendLine(lines[9], startOfLines + duration * 3);
  extendLine(lines[8], startOfLines + duration * 3);
  extendLine(lines[7], startOfLines + duration * 4);


});
